import React from "react";
import { Link } from "react-router-dom";
import { auth } from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";

function Navbar() {
  const [user] = useAuthState(auth);

  const logout = () => auth.signOut();

  return (
    <nav>
      {!user ? (
        <>
          <Link to="/login">Login</Link> | <Link to="/signup">Signup</Link>
        </>
      ) : (
        <>
          <Link to="/main">Main</Link> | <Link to="/booking">Booking</Link> |{" "}
          <button onClick={logout}>Logout</button>
        </>
      )}
      <span style={{ marginLeft: "20px" }}>
        <Link to="/admin">Admin</Link>
      </span>
    </nav>
  );
}

export default Navbar;
